export const currencyList = [
	{ code: 'EUR', description: 'EURO', isDefault: true },
	{ code: 'GBP', description: 'Pound sterling', isDefault: false },
	{ code: 'USD', description: 'United States dollar', isDefault: false }
];

export const formValues = [
	{ value: 'Coil', display: 'fastlane.itemlist.quality.calculator.coil' },
	{ value: 'Sheet', display: 'fastlane.itemlist.quality.calculator.sheet' },
	{ value: 'Slitting Coil', display: 'fastlane.itemlist.product.slitting_coil' },
	{ value: 'Form Blanks', display: 'fastlane.itemlist.product.form_blank' }
];

export const formValuesForAllLang = new Map([
	['fastlane-mail.form_coil', 'Coil'],
	['fastlane-mail.form_sheet', 'Sheet'],
	['fastlane-mail.form_slitting_coil', 'Slitting Coil'],
	['fastlane-mail.form_blank', 'Form Blanks']
]);

export const coilList = [
	{ value: 'None', display: 'fastlane.itemlist.product.coil_axis.default' },
	{ value: 'Horizontal', display: 'fastlane.itemlist.product.coil_axis.horizontal' },
	{ value: 'Vertical', display: 'fastlane.itemlist.product.coil_axis.vertical' }
];
export const innerDiameterList = [
	{ value: 'None', display: 'fastlane.itemlist.coil.inner.diameter.NA' },
	{ value: '508 mm', display: 'fastlane.itemlist.coil.inner.diameter.508mm' },
	{ value: '610 mm', display: 'fastlane.itemlist.coil.inner.diameter.610mm' }
];

export const unitListForCoil = [{ value: 'tons', display: 'ecall-off.tons' }];

export const unitListForCoilForAllLang = new Map([['fastlane-mail.unit_ton', 'tons']]);

export const unitListForSheet = [
	{ value: 'sheets', display: 'fastlane.itemlist.unit.sheets' },
	{ value: 'tons', display: 'ecall-off.tons' },
	{ value: 'm2', display: 'unit.m2' }
];

export const unitListForSheetForAllLang = new Map([
	['fastlane-mail.unit_sheets', 'sheets'],
	['fastlane-mail.unit_ton', 'tons'],
	['fastlane-mail.unit_m2', 'm2']
]);

export const unitListForBlank = [{ value: 'blanks', display: 'fastlane.itemlist.unit.blanks' }];

export const unitListForBlankForAllLang = new Map([['fastlane-mail.unit_blanks', 'blanks']]);

export const langList = ['en-GB', 'fr-FR'];

export const units = [...unitListForCoil, ...unitListForSheet, ...unitListForBlank];

export const FORM_COIL = 'Coil';
export const FORM_SLITTING_COIL = 'Slitting Coil';
export const FORM_SHEET = 'Sheet';
export const FORM_BLANK = 'Form Blanks';
export const UNIT_TONS = 'tons';
export const REMOVE_MIN_COUNT = 2;
export const DUPLICATE_MAX_COUNT = 100;
export const NONE_CODE = 'None';
export const UNIT_SHEET = 'sheets';
export const UNIT_M2 = 'm2';
export const UNIT_BLANKS = 'blanks';
export const SHIP_TO_CUSTOM = 'CUSTOM';
export const SHIP_TO_LATER = 'LATER';
export const SHIP_TO_BOC = 'BOC';
export const ERROR_MIME = 'ERROR MIME';
export const ERROR_SIZE = 'ERROR SIZE';
export const ERROR_FILE_NAME = 'ERROR FILE NAME';
export const MIME_TYPE = 'MIME--TYPE';
export const EMPTY_LINE = '-emptyline-';
export const EMPTY_DISPLAY = '[empty]';
export const SESSION_UPDATED = 'session updated';
/** number of days from Jan 1, 1900 to Jan 1, 1970 */
export const EPOCH = 25_569;
/** number of miliseconds in a day */
export const MILLISECONDS_IN_A_DAY = 86_400_000;

export const plant = [
	{ code: ' ', value: '-- None --' },
	{ code: '0007', value: 'ArcelorMittal Eisenhüttenstadt' },
	{ code: '0030', value: 'ArcelorMittal Asturias (Avilés)' },
	{ code: '0031', value: 'ArcelorMittal Extebarri' },
	{ code: '0035', value: 'ArcelorMittal Asturias (Gijón)' },
	{ code: '0036', value: 'ArcelorMittal Lesaka' },
	{ code: '1300', value: 'AMDS France' },
	{ code: '2800', value: 'ESP' },
	{ code: '3250', value: 'ArcelorMittal Dudelange' },
	{ code: '4350', value: 'ArcelorMittal Atlantique' },
	{ code: '4360', value: 'ArcelorMittal Méditerrannée' },
	{ code: '4369', value: 'ArcelorMittal St. Chély' },
	{ code: '4370', value: 'ArcelorMittal Lorraine' },
	{ code: '6150', value: 'ArcelorMittal Liège' },
	{ code: '6630', value: 'ArcelorMittal Avellino' },
	{ code: '6650', value: 'ArcelorMittal Italia' },
	{ code: '7320', value: 'AM Gent' },
	{ code: '7440', value: 'ArcelorMittal Sagunto' },
	{ code: '7460', value: 'ArcelorMittal Bremen' },
	{ code: '7510', value: 'ArcelorMittal Kraków' },
	{ code: '7520', value: 'ArcelorMittal Sosnowiec' },
	{ code: '7530', value: 'ArcelorMittal Swietochlowice' },
	{ code: '7540', value: 'ArcelorMittal Skopje (CRM)' },
	{ code: '7550', value: 'ArcelorMittal Ostrava' },
	{ code: '7554', value: 'ArcelorMittal Frydek-Mistek' },
	{ code: '7560', value: 'ArcelorMittal Galati' },
	{ code: '7590', value: 'ArcelorMittal Dabrowa' },
	{ code: '7820', value: 'AMDS Germany' },
	{ code: '8141', value: 'AM Tailored Blanks Gent' },
	{ code: '86D0', value: 'BORCELIK CELIK SANAYII TICARET' },
	{ code: '8810', value: 'AMDS UK' },
	{ code: '9360', value: 'ArcelorMittal Sestao' },
	{ code: '9503', value: 'ArcelorMittal Packaging Tilleur' },
	{ code: '9506', value: 'ArcelorMittal Packaging Avilés' },
	{ code: '9507', value: 'ArcelorMittal Packaging Etxebarri' },
	{ code: '9508', value: 'ArcelorMittal Packaging Italy' },
	{ code: '9509', value: 'ArcelorMittal Packaging Basse-Indre' },
	{ code: '9510', value: 'ArcelorMittal Packaging Florange' },
	{ code: 'NYT', value: 'NOT YET DEFINED' },
];

export const plantsInFrench = [
	{ code: ' ', value: '-- Aucun --' },
	{ code: '0007', value: 'ArcelorMittal Eisenhüttenstadt' },
	{ code: '0030', value: 'ArcelorMittal Asturias (Avilés)' },
	{ code: '0031', value: 'ArcelorMittal Extebarri' },
	{ code: '0035', value: 'ArcelorMittal Asturias (Gijón)' },
	{ code: '0036', value: 'ArcelorMittal Lesaka' },
	{ code: '1300', value: 'AMDS France' },
	{ code: '2800', value: 'ESP' },
	{ code: '3250', value: 'ArcelorMittal Dudelange' },
	{ code: '4350', value: 'ArcelorMittal Atlantique' },
	{ code: '4360', value: 'ArcelorMittal Méditerrannée' },
	{ code: '4369', value: 'ArcelorMittal St. Chély' },
	{ code: '4370', value: 'ArcelorMittal Lorraine' },
	{ code: '6150', value: 'ArcelorMittal Liège' },
	{ code: '6630', value: 'ArcelorMittal Avellino' },
	{ code: '6650', value: 'ArcelorMittal Italia' },
	{ code: '7320', value: 'AM Gent' },
	{ code: '7440', value: 'ArcelorMittal Sagunto' },
	{ code: '7460', value: 'ArcelorMittal Bremen' },
	{ code: '7510', value: 'ArcelorMittal Kraków' },
	{ code: '7520', value: 'ArcelorMittal Sosnowiec' },
	{ code: '7530', value: 'ArcelorMittal Swietochlowice' },
	{ code: '7540', value: 'ArcelorMittal Skopje (CRM)' },
	{ code: '7550', value: 'ArcelorMittal Ostrava' },
	{ code: '7554', value: 'ArcelorMittal Frydek-Mistek' },
	{ code: '7560', value: 'ArcelorMittal Galati' },
	{ code: '7590', value: 'ArcelorMittal Dabrowa' },
	{ code: '7820', value: 'AMDS Germany' },
	{ code: '8141', value: 'AM Tailored Blanks Gent' },
	{ code: '86D0', value: 'BORCELIK CELIK SANAYII TICARET' },
	{ code: '8810', value: 'AMDS UK' },
	{ code: '9360', value: 'ArcelorMittal Sestao' },
	{ code: '9503', value: 'ArcelorMittal Packaging Tilleur' },
	{ code: '9506', value: 'ArcelorMittal Packaging Avilés' },
	{ code: '9507', value: 'ArcelorMittal Packaging Etxebarri' },
	{ code: '9508', value: 'ArcelorMittal Packaging Italy' },
	{ code: '9509', value: 'ArcelorMittal Packaging Basse-Indre' },
	{ code: '9510', value: 'ArcelorMittal Packaging Florange' },
	{ code: 'NYT', value: 'PAS ENCORE DEFINI' }
];

export const rddTypes = [
	{ code: '1', value: 'fastlane.wizard.items.details.day' },
	{ code: '2', value: 'fastlane.wizard.items.details.week' }

];
export const transportMode = [
	{ value: 'Train', display: 'transport.mode.train' },
	{ value: 'Boat', display: 'transport.mode.boat' },
	{ value: 'Truck', display: 'transport.mode.truck' },
	{ value: 'Plane', display: 'transport.mode.plane' }
];

export const transportModeForAllLang = new Map([
	['fastlane-mail.transport.mode.train', 'Train'],
	['fastlane-mail.transport.mode.boat', 'Boat'],
	['fastlane-mail.transport.mode.truck', 'Truck'],
	['fastlane-mail.transport.mode.plane', 'Plane']
]);

export const unitsForAllLang = new Map([
	['fastlane-mail.unit_sheets', 'sheets'],
	['fastlane-mail.unit_ton', 'tons'],
	['fastlane-mail.unit_m2', 'm2'],
	['fastlane-mail.unit_blanks', 'blanks']
]);

export const defaultValueForAllLang = new Map([['global.none', 'None']]);

export const innerDiameterDefaultValueAllLang = new Map([['fastlane-mail.unit_NA', 'None']]);

export const CONFIRMED_STATUS_INDEX = 4;

export const DECISION_STATUS_INDEX = 3;

export const MATERIAL_AVAILABILTY_STATUS_INDEX = 2;

export enum PrototypeStatus {
	DRAFT = 'draft',
	REQUESTED = 'requested',
	PROPOSAL = 'proposal',
	ACCEPTED = 'accepted',
	REFUSED = 'refused',
	CLOSED = 'closed',
	NOTAVAILABLE = 'notAvailable'
}
